import { useCallback, useMemo, useRef } from "react";

import { mergeOrder, restoreIndex } from "../restoreOrder";

export function useRestoreOrder() {
  const order = useRef<string[]>([]);

  const track = useCallback((keys: readonly string[]) => {
    order.current = mergeOrder(order.current, keys);
  }, []);

  const indexFor = useCallback((key: string, keys: readonly string[]) => {
    order.current = mergeOrder(order.current, keys);
    return restoreIndex(order.current, keys, key);
  }, []);

  return useMemo(() => ({ track, indexFor }), [track, indexFor]);
}
